import { graphql } from "gatsby";
import React, { FC } from "react";

import { useFormattedDate } from "../../../hooks/use-formatted-date";
import { Pill } from "../../forms";
import { TagColors, TagDimensions } from "../../forms/elements/tags/types";
import { HeroBannerMedia } from "../../strips/hero-banner/hero-banner-media";

export interface WhatsNextStripProps extends Queries.WhatsNextStripDataFragment {}

export const WhatsNextStrip: FC<WhatsNextStripProps> = ({
  title,
  date,
  categories,
  bannerMedia,
}) => {
  const formattedDate = useFormattedDate(date, {
    year: "numeric",
    month: "2-digit",
    day: "numeric",
  });

  return (
    <div className="relative w-full min-h-screen sm:min-h-128 overflow-hidden [word-break:break-word] ">
      {bannerMedia && (
        <HeroBannerMedia media={{ ...bannerMedia, placeholderUrl: "", url: "" }} alt="" />
      )}
      {(title || formattedDate) && <div className="absolute w-full h-full bg-dark opacity-40" />}
      <div className="absolute w-full h-full flex flex-col justify-center items-center">
        {!!categories?.length && (
          <div className="flex gap-2 flex-wrap mb-8justify-center">
            {categories.map((category, i) => {
              return (
                <Pill
                  key={i}
                  color={TagColors.Neutral}
                  dimension={TagDimensions.Medium}
                  checked
                  readOnly
                >
                  {category?.label}
                </Pill>
              );
            })}
          </div>
        )}
        {title && (
          <div className="text-light font-medium  text-5xl xl:text-7xl text-center max-w-[90%] lg:max-w-[80%] pt-12 pb-20">
            {title}
          </div>
        )}
        {formattedDate && (
          <div className="text-light font-extralight text-xl lg:max-w-3xl">{formattedDate}</div>
        )}
      </div>
    </div>
  );
};

export const query = graphql`
  fragment WhatsNextStripData on ContentfulWhatsNext {
    title
    date
    categories {
      ...WhatsNextCategoryData
    }
    defaultLocaleEntry {
      title
      categories {
        ...WhatsNextCategoryData
      }
    }
    node_locale
    bannerMedia {
      gatsbyImageData
      mimeType
    }
  }
`;
